import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { GridContainer, CenterContent } from 'global/components/perform-grid';
import { Collapse, Icon, Link, List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { BookmarkPlusIcon } from 'global/components/PerformIcons';
import { Button } from 'global/components/Button';
import colors from 'global/styles/colors';
import ThumbDownOutlinedIcon from '@material-ui/icons/ThumbDownOutlined';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import { get, set, size, upperFirst, sortBy, first } from 'global/lib/lodash';
import clsx from 'clsx';
import { ImageList } from 'global/components/image';
import { userHasPermissions } from 'redux/actions/userLogin';
import Create, { Clone } from './create';
import { Loader } from 'global/styles';
import BookmarkModal from './bookmark-modal';
import useStyles from './styles';
import { useUser } from 'global/hooks/useUser';
import { MoreDrop } from 'global/components/more-drop';
import { CreateModal } from '../../task/CreateModal';
import useRetrieveData from 'global/hooks/useRetrieveData';
import TaskDetail from '../../task/TaskDetail';
import TaskNotify from '../../task/TaskNotify';
import { useLoaded } from 'global/hooks/useLoaded';
import sendData from 'redux/actions/sendData';

export const OpHeader = (props) => {
  const { icon, title, color } = props;
  const classes = useStyles();

  return (
    <div className={classes.opHeader}>
      <div style={{ color }}>{icon}</div>
      <div className={classes.opTitle}>{title}</div>
    </div>
  );
};

export const LI = (props) => {
  const { open, li, toggleOpen, color, userCanEdit, canBookmark, onEditClick, cloning, printView } = props;
  const classes = useStyles({ color, printView });
  const isOpen = get(open, li.id);
  const [taskCreate, setTaskCreate] = useState({ open: false });
  const [activeTask, setActiveTask] = useState();
  const [showAll, setShowAll] = useState(props.collapseContentOnly ? false : true);
  const [state, setState] = useState({
    loadingbm: false,
  });

  const hasProgeny = !!size(get(li, 'progeny', []));
  const isCloning = get(cloning, li.id) || state.loadingbm;

  const images = {
    site: sortBy(
      li.images.filter((img) => img.collectionName === 'report-section-site-images'),
      'orderColumn'
    ),
    bp: sortBy(
      li.images.filter((img) => img.collectionName === 'report-section-bp-images'),
      'orderColumn'
    ),
  };

  const tasks = useRetrieveData(
    { url: '/tasks' },
    {
      build: ['tasks'],
      params: {
        filter: {
          report_section_id: li.id,
        },
      },
    }
  );

  const impactTitle = (() => {
    const t = get(li, 'impactTitle');
    if (t === 'homeowner_impact') {
      return 'Impact to Homeowner';
    } else if (t === 'builder_impact') {
      return 'Impact to Builder';
    } else {
      return t;
    }
  })();
  const isQual = impactTitle || get(li, 'bpTitle');

  const collapseContent = () => {
    return (
      <div className={classes.collapseContainer}>
        <div className={classes.box}>
          <div className={classes.title}>Site Observations</div>
          <div className={clsx(classes.innerHtml, !!size(images.site) && classes.innerHasImage, 'innerHtml')} dangerouslySetInnerHTML={{ __html: li.body }} />
          {!!size(images.site) && (
            <div className={clsx(classes.imagesContainer, 'imgContainer')}>
              <ImageList printView={printView} images={images.site} showCaption unsetHeight={printView ? true : false} />
            </div>
          )}
        </div>

        {isQual && !showAll && (
          <Link className={classes.showMore} onClick={() => setShowAll(true)}>
            more
          </Link>
        )}

        {isQual && showAll && (
          <>
            <div className={classes.box}>
              <div className={classes.title}>{impactTitle}</div>
              <div className={clsx(classes.innerHtml, classes.innerHasImage)} dangerouslySetInnerHTML={{ __html: get(li, 'impactBody') }} />
              <div className={classes.imagesContainer}></div>
            </div>

            <div className={classes.box}>
              <div className={classes.title}>{get(li, 'bpTitle', 'Best Practice')}</div>
              <div className={clsx(classes.innerHtml, classes.innerHasImage, 'innerHtml')} dangerouslySetInnerHTML={{ __html: get(li, 'bpBody') }} />
              {!!size(images.bp) && (
                <div className={clsx(classes.imagesContainer, 'imgContainer')}>
                  <ImageList printView={printView} images={images.bp} showCaption unsetHeight={printView ? true : false} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  const bookmarkClick = async () => {
    try {
      setState((s) => ({ ...s, loadingbm: true }));
      await props.bookmarkClick(li);
    } catch (err) {
      console.error(err);
    } finally {
      setState((s) => ({ ...s, loadingbm: false }));
    }
  };

  const options = [
    {
      title: 'Edit',
      icon: 'edit',
      onClick: onEditClick,
      hide: !userCanEdit,
    },
    {
      title: 'Create Template',
      icon: <BookmarkPlusIcon />,
      onClick: () => bookmarkClick(li),
    },
    {
      title: 'Create Task',
      icon: 'library_add_check',
      onClick: () => {
        setTaskCreate({
          open: true,
          highlight: li,
          assessment: li.assessment,
          realmId: get(li, 'assessment.realmId'),
          taskName: li.title,
          topContent: () => {
            return (
              <div className={classes.createTopContent}>
                <LI {...props} collapseContentOnly />
              </div>
            );
          },
          onClose: async (created) => {
            if (created) {
              await tasks.update();
            }
            setTaskCreate({ open: false });
          },
        });
      },
    },
  ].filter((f) => !f.hide);

  if (props.collapseContentOnly) {
    return collapseContent();
  }

  return (
    <div className={classes.listItem}>
      <ListItem key={li.id} dense button onClick={() => toggleOpen(li)}>
        {printView ? (
          <ListItemText disableTypography primary={<div style={{ fontSize: '1.17em', fontWeight: 'bold' }}>{li.title}</div>} secondary={get(li, 'superset.name', '')} />
        ) : (
          <ListItemText primary={li.title} secondary={get(li, 'superset.name', '')} />
        )}
        <ListItemSecondaryAction>
          {!printView && (
            <div className={'iconContainer'}>
              <Icon className={'arrowIcon'} onClick={() => toggleOpen(li)}>
                {isOpen ? 'arrow_drop_down' : 'arrow_right'}
              </Icon>
              {canBookmark && hasProgeny && (isCloning ? <Loader size={18} /> : <Icon onClick={() => bookmarkClick(li)}>{'bookmark'}</Icon>)}
              {!!size(tasks.data) && <Icon onClick={() => setActiveTask(tasks.data[0])}>{'library_add_check'}</Icon>}
              <MoreDrop options={options} />
            </div>
          )}
        </ListItemSecondaryAction>
      </ListItem>
      <Collapse in={isOpen}>{collapseContent()}</Collapse>
      <CreateModal {...taskCreate} />
      {activeTask && <TaskDetail taskId={activeTask.id} onClose={() => setActiveTask()} />}
    </div>
  );
};

const ItemList = forwardRef((props, ref) => {
  const { items, type, openCreate, cloneItem, cloning } = props;

  const [open, setOpen] = useState({});

  const opProps = (() => {
    if (type === 'Best Practices') {
      return {
        icon: <ThumbUpOutlinedIcon fontSize="small" />,
        title: 'Best Practices',
        color: colors.buttonSuccess,
      };
    } else if (type === 'Quality Opportunities') {
      return {
        icon: <ThumbDownOutlinedIcon fontSize="small" />,
        title: 'Quality Opportunities',
        color: colors.redIcon,
      };
    }
  })();

  const toggleOpen = (li) => {
    const op = { ...open };
    if (get(op, li.id)) {
      delete op[li.id];
    } else {
      op[li.id] = true;
    }
    setOpen(op);
  };

  const bookmarkClick = async (li) => {
    const isClone = size(get(li, 'progeny', []));
    if (isClone) {
      const hl = get(li, 'progeny.0');
      const result = first(await sendData({ url: `/report-sections/${hl.id}` }, { normalize: { build: ['reportSections'] }, params: { include: 'images' } }));
      openCreate(result, true);
    } else {
      cloneItem(li);
    }
  };

  const expandAll = ({ check }) => {
    let allOpen = true;
    for (let i = 0; i < check.length; i++) {
      const { current } = check[i];
      if (Object.keys(current.open).length < current.items.length) {
        allOpen = false;
        break;
      }
    }
    if (allOpen) {
      return setOpen({});
    }
    const op = {};
    items.map((it) => (op[it.id] = true));
    setOpen(op);
  };

  const classes = useStyles({ color: opProps.color });

  set(ref, 'current.expandAll', expandAll);
  set(ref, 'current.open', open);
  set(ref, 'current.items', items);

  const hasItems = !!size(items);

  return (
    <div ref={ref}>
      {hasItems && <OpHeader {...opProps} />}

      {hasItems && (
        <List className={classes.list}>
          {items.map((li) => (
            <LI open={open} {...props} onEditClick={() => props.onEditClick(li)} cloning={cloning} toggleOpen={toggleOpen} li={li} bookmarkClick={bookmarkClick} color={opProps.color} />
          ))}
        </List>
      )}
    </div>
  );
});

export default (props) => {
  const classes = useStyles();
  const [best, setBest] = useState([]);
  const [qual, setQual] = useState([]);
  const [cloning, setCloning] = useState({});
  const [create, setCreate] = useState({
    open: false,
    onClose: () => {
      highlights.update();
      setCreate((c) => ({ ...c, open: false }));
    },
  });
  const [bookModal, setBookModal] = useState({
    open: false,
    onClose: () => {
      highlights.update();
      setBookModal((c) => ({ ...c, open: false }));
    },
    onClick: (hl) => openCreate(hl, true),
  });
  const bref = useRef();
  const qref = useRef();
  const { me } = useUser();

  const { assessment, highlights, printView, canShowScores } = props;
  const status = get(assessment, 'data.status');
  const { data, loading } = highlights;

  const realm_id = get(assessment, 'data.realm.id');

  useEffect(() => {
    if (!loading) {
      const _best = [];
      const _qual = [];

      data
        .sort((a, b) => {
          const inta = parseInt(get(a, 'superset.id'));
          const intb = parseInt(get(b, 'superset.id'));

          if (inta === intb) {
            const titlea = get(a, 'title').toLowerCase();
            const titleb = get(b, 'title').toLowerCase();
            if (titlea < titleb) {
              return -1;
            }
            if (titlea > titleb) {
              return 1;
            }
            return 0;
          }
          return inta - intb;
        })
        .map((d) => {
          const type = get(d, 'sectionType');
          if (type === 'Best Practices') {
            _best.push(d);
          } else if (type === 'Quality Issues') {
            _qual.push(d);
          }
        });

      setBest(_best);
      setQual(_qual);

      if (printView) {
        setTimeout(() => expandAll(), 500);
      }
    }
  }, [loading]);

  const openCreate = (highlight, isTemplate = false) => {
    setCreate({
      ...create,
      assessment,
      highlights,
      highlight,
      isTemplate,
      cloneItem,
      open: true,
    });
  };

  const cloneItem = async (highlight) => {
    try {
      setCloning((cl) => ({ ...cl, [highlight.id]: true }));
      // const images = await Promise.all(get(highlight, 'images', []).map(async img => {
      //   const file = await getBase64Image(img.fullUrl, true);
      //   return {
      //     collection: get(img, 'collectionName'),
      //     name: get(img, 'name'),
      //     caption: get(img, 'caption', ''),
      //     file,
      //   }
      // }));

      const cloneData = {
        ...highlight,
        realm_id: get(me, 'realm.id'),
        // images,
      };

      await Clone(cloneData, assessment.data);

      await highlights.update();
      setCloning((cl) => ({ ...cl, [highlight.id]: false }));
    } catch (err) {
      alert(`Failed to clone item: ${err.message}`);
    }
  };

  const onAdd = (fromBook = false) => {
    if (fromBook) {
      setBookModal({
        ...bookModal,
        cloneItem,
        onClick: (hl) => openCreate(hl, true),
        open: true,
      });
    } else {
      openCreate();
    }
  };

  const onEditClick = (highlight) => {
    openCreate(highlight);
  };

  const expandAll = () => {
    [bref, qref].map((ref) => {
      get(ref, 'current.expandAll', () => 0)({ check: [bref, qref] });
    });
  };

  const userCanEdit = (() => {
    if (status === 'published') {
      return false;
    }

    if (props.userCanEdit) {
      return true;
    }
    if (status === 'review') {
      return props.userCanEdit || get(assessment, 'data.viewers', []).find((v) => v.id == me.id);
    } else {
      return false;
    }
  })();

  const canBookmark = userHasPermissions(['createReports']) && props.userCanEdit;

  const listprops = {
    userCanEdit,
    cloning,
    cloneItem,
    openCreate,
    onEditClick,
    canBookmark,
    printView,
  };

  const loadingAtAll = (() => {
    return assessment.loading || loading;
  })();

  useLoaded(props, [loadingAtAll]);

  return (
    <GridContainer>
      <CenterContent fullWidth={printView} selfCenter>
        <TaskNotify realmId={realm_id || null} />
        <div className={classes.container}>
          {!canShowScores ? (
            loadingAtAll ? (
              <div style={{ padding: 12 }}>
                <Loader />
              </div>
            ) : (
              <div style={{ padding: 12 }}>{`You don't have access to view highlights while this report is in ${upperFirst(status)}.`}</div>
            )
          ) : null}

          {canShowScores && (
            <>
              {!printView && (
                <div className={classes.buttonContainer}>
                  {userCanEdit && (
                    <Button startIcon={<Icon>add</Icon>} onClick={() => onAdd()}>
                      ADD
                    </Button>
                  )}
                  {userCanEdit && (
                    <Button startIcon={<Icon>bookmark_border</Icon>} onClick={() => onAdd(true)}>
                      Add From Template
                    </Button>
                  )}
                  <Button startIcon={<Icon>arrow_drop_down</Icon>} bgColor={colors.buttonSuccess} onClick={expandAll}>
                    Expand All
                  </Button>
                  {highlights.loading && <Loader style={{ position: 'relative', top: 5 }} size={20} />}
                </div>
              )}

              <ItemList ref={bref} items={best} {...listprops} type="Best Practices" />
              <ItemList ref={qref} items={qual} {...listprops} type="Quality Opportunities" />
            </>
          )}
        </div>

        <Create {...create} assessment={assessment} />
        <BookmarkModal {...bookModal} />
      </CenterContent>
    </GridContainer>
  );
};
